import Vue from "vue";
import store from '@/store'
const getOrganizationName = function (value) {
  return store.getters['dictionaries/getOrganizationName'](value);
};

const getBusinessGroupName = function (value) {
  return store.getters[ 'dictionaries/getBusinessGroupName'](value);
};

Vue.filter("getBusinessGroupName", getBusinessGroupName);
Vue.filter("getOrganizationName", getOrganizationName);


export {
  getOrganizationName,
  getBusinessGroupName
}
